import { CreateBlockVueDomV3, createRecord, CreateWidgetFromFirebaseNode } from '../components/v3/lib/vue-dom-obj'
import { PageEngineCommands } from './AddSectionCommand'

/**
 * Handles Section Swap Action
 */

export class SwapSectionCommand extends PageEngineCommands {
  constructor(pageEngineComponent, oldBlockNode, newBlockNode) {

    super()
    this._pageEngineComponent = pageEngineComponent

    this._oldBlockNode = oldBlockNode;
    this._newBlockNode = newBlockNode;

    this.indexToBeReplacedAt = Number(oldBlockNode['.key']);

    this._oldWidget = CreateWidgetFromFirebaseNode(oldBlockNode, true)
    this._newWidget = CreateWidgetFromFirebaseNode(newBlockNode, true)

    // _addedGridStackNodeElement: for the purpose of redo and undo,
    // we want to track already created vueElement, just in case they are part of another undo or redo action
    this._addedGridStackNodeElement = null
    this._nodeRemoved = false
  }

  get hasChanges() {
    return true
  }

  async execute() {

    let newRecord = null
    let value = await this.firebaseRef.splice(this.indexToBeReplacedAt, 1, this._newWidget);
    
    if (this._addedGridStackNodeElement) 
    {
      // use existing record if reverted
      newRecord = this._addedGridStackNodeElement.fbNode
      this._nodeRemoved = false
    } 
    else 
    {
      const vdom = createRecord(value.snapshot)
      const children = vdom.children || vdom['.value']
      newRecord = CreateBlockVueDomV3( children[this.indexToBeReplacedAt], `${this.indexToBeReplacedAt}`, vdom['.path'])
    }

    this.replaceBlockAtPosition(newRecord.data.props.vnodeId, newRecord, this.indexToBeReplacedAt);

    this.$nextTick(() => {
      this._addedGridStackNodeElement = this.$children[this.indexToBeReplacedAt]
      this._addedGridStackNodeElement.$el.scrollIntoView({ behavior: 'smooth'})
      this._pageEngineComponent.$mount()
    });

  }

  async unExecute() {
    if (this._addedGridStackNodeElement && !this._nodeRemoved) {

      this.firebaseRef.splice(this.indexToBeReplacedAt, 1, this._oldWidget).then((value) => {

        const vdom = createRecord(value.snapshot)
        const children = vdom.children || vdom['.value']
        let newRecord = CreateBlockVueDomV3( children[this.indexToBeReplacedAt], `${this.indexToBeReplacedAt}`, vdom['.path'])

        this.replaceBlockAtPosition(newRecord.data.props.vnodeId, newRecord, this.indexToBeReplacedAt);

        this.$nextTick(() => {
          this._pageEngineComponent.$mount()
          this._nodeRemoved = true
        })

      });
    }
  }
}
